/**
 * 商品一覧ページのランダム表示制御
 *
 * 仕様:
 * - /collections/{handle} ページが対象
 * - sort_by / filter.* が付いている場合はランダムしない
 * - 見た目重視の「重み付きランダム」を使用
 * - results-list / Ajax 描画完了後に実行
 * - CLS / チラつき防止のため data-product-randomizing フラグを使用
 */

console.log('[product-randomize] loaded');

/**
 * コレクション商品一覧ページかどうか
 */
const isCollectionPage = () => {
  return window.location.pathname.startsWith('/collections/');
};

/**
 * 並び順に意味を持つパラメータがあるか
 */
const hasMeaningfulParams = () => {
  const params = new URLSearchParams(window.location.search);

  for (const key of params.keys()) {
    if (key === 'sort_by') return true;
    if (key.startsWith('filter.')) return true;
  }
  return false;
};

/**
 * 重み付きランダム
 * 下にあった商品ほど上に来やすくする（視覚的ランダム感重視）
 */
const weightedShuffle = (items) => {
  const length = items.length;

  return items
    .map((item, index) => {
      // index が大きいほど（下にあるほど）重みが増える
      const weight = Math.random() + index / length;
      return { item, weight };
    })
    .sort((a, b) => b.weight - a.weight)
    .map(({ item }) => item);
};

/**
 * 商品カードを並び替え
 */
const shuffleProducts = () => {
  if (!isCollectionPage()) return;
  if (hasMeaningfulParams()) return;

  const grid = document.querySelector('[product-grid-view]');
  if (!grid) return;

  const items = Array.from(
    grid.querySelectorAll('.product-grid__item')
  );

  if (items.length <= 1) return;

  const shuffledItems = weightedShuffle(items);

  shuffledItems.forEach((item) => {
    grid.appendChild(item);
  });
};

/**
 * ランダム処理中フラグを立てる（CSSで非表示制御）
 */
document.documentElement.setAttribute(
  'data-product-randomizing',
  'true'
);

/**
 * results-list / Ajax 描画完了待ち
 */
const observer = new MutationObserver(() => {
  const itemExists = document.querySelector('.product-grid__item');
  if (!itemExists) return;

  shuffleProducts();

  // 並び替え完了 → 表示
  document.documentElement.removeAttribute(
    'data-product-randomizing'
  );

  observer.disconnect();
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});
